import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-overlay">
      <div className="spinner"></div>
      <p>Carregando...</p>
    </div>
  );
};

export default LoadingScreen;
